module.exports = __webpack_public_path__ + "img/ic_store_function_img3.91370c30.png";